import { render, staticRenderFns } from "./MaterialOnlineOrReturn.vue?vue&type=template&id=d5b41e8e&scoped=true"
import script from "./MaterialOnlineOrReturn.vue?vue&type=script&lang=js"
export * from "./MaterialOnlineOrReturn.vue?vue&type=script&lang=js"
import style0 from "./MaterialOnlineOrReturn.vue?vue&type=style&index=0&id=d5b41e8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b41e8e",
  null
  
)

export default component.exports